var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.icons),function(c){return _c('el-tooltip',{key:c,attrs:{"content":c,"placement":"top"}},[_c('img',{staticClass:"my-icon",attrs:{"src":("./256/" + (c.toLowerCase()) + ".png"),"alt":c}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }